import Mosaic, { Router } from "mosaic-framework";
import { createBrowserHistory } from "history";

import Home from './pages/home';
import Install from './pages/install';
import MosaicDocs from './pages/mosaic';
import InitializationDocs from './pages/initialization';
import NamingDocs from './pages/naming';
import ElementDocs from './pages/element';
import LifecycleDocs from './pages/lifecycle';
import DataDocs from './pages/data';
import ActionDocs from './pages/actions';
import ViewDocs from './pages/view';
import MixinDocs from './pages/mixins';
import ShadowDocs from './pages/shadowdom';
import PortfolioDocs from './pages/portfolio';
import RouterDocs from './pages/router';
import DescendantsDocs from './pages/descendants';
import StylesheetsDocs from './pages/stylesheets';


const router = new Router('root');
const history = createBrowserHistory();

router.addRoute('/', Home);
router.addRoute('/install', Install);
router.addRoute('/mosaic', MosaicDocs);
router.addRoute('/initialization', InitializationDocs);
router.addRoute('/naming', NamingDocs);
router.addRoute('/element', ElementDocs);
router.addRoute('/lifecycle', LifecycleDocs);
router.addRoute('/data', DataDocs);
router.addRoute('/actions', ActionDocs);
router.addRoute('/view', ViewDocs);
router.addRoute('/mixins', MixinDocs);
router.addRoute('/shadowdom', ShadowDocs);
router.addRoute('/portfolio', PortfolioDocs);
router.addRoute('/router', RouterDocs);
router.addRoute('/descendants', DescendantsDocs);
router.addRoute('/stylesheets', StylesheetsDocs);
router.setNotFound(new Mosaic({
    name: 'not-found',
    created() {
        const nav = document.getElementById('this-nav-bar');
        nav.router = router;

        window.scrollTo({ top: 0 });
    },
    view() {
        return html`
            <navigation-bar id='this-nav-bar'></navigation-bar>

            <h1>🤷‍♂️</h1>
            <h1>This page couldn't be found!</h1>
            <h2>
                But you can still use the navigation links in
                the top right to go to a different page!
            </h2>
            <br><br><br><br><br><br><br><br><br>
            <br><br><br><br>

            <app-footer></app-footer>
        `
    }
}));
router.paint();

// Event listener on history so the menu button will show on the right pages.
history.listen(location => {
    const menubtn = document.getElementById('menu-button');
    menubtn.style.display = location.pathname !== '/' && location.pathname !== '/install' ? 'block' : 'none';

    if(menubtn.onclick) return;
    menubtn.onclick = () => {
        const menu = document.getElementById('doc-menu');
        menu.style.transform = 'translateX(0%)';
    }
});
